export default __webpack_public_path__ + "static/media/Vikings.62e47baa.jpg";